import React, { Component, Fragment, useEffect, useState } from "react";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import DownloadPDF from "../../images/download-to-pdf-icon-0.jpg";
import DownloadExcel from "../../images/download-to-excel-icon-0.jpg";
import Pdf from "../../images/pdf.png";
import Excel from "../../images/excel.png";


const StdAcmdCaseDetailsTableComponent = (props) => {
    const getInitialStatus = (statusList) => {
        return statusList.length ? statusList[statusList.length - 1].statusName : ""
    }

    return (
        <>
            {Array.isArray(props.applicants) && props.applicants.filter(x => !x.isAIR).length
                ?
                <>

                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">{props.context.t("CurrentActivity.Name.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.caseType.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.FdaDate.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.xrtwDate.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.rtw.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.rtwDate.Text")}</th>
                                <th scope="col">{props.context.t("CurrentActivity.CurrentStatus.Text")}</th>
                                {/* <th scope="col">{props.context.t("CurrentActivity.statusDate.Text")}</th> */}
                                <th scope="col">{props.context.t("CurrentActivity.DateClosed.Text")}</th>
                                {/* {!props.isRedirectCurrentActivityScreen && <th scope="col">Action</th>} */}
                            </tr>
                        </thead>
                        <tbody>
                            {props.applicants.map((applicant, index) => (
                                !applicant.isAIR ?
                                    <Fragment key={`${applicant.ein}-${index}`}>
                                        <tr
                                            className={"case-status-tb-row " + props.getStatusColorClass(getInitialStatus(applicant.fileStatusInformation))}

                                        >
                                            <td onClick={() => props.addRow(index)}>{applicant.firstName + " " + applicant.lastName}</td>
                                            <td onClick={() => props.addRow(index)}>{applicant.statusDisplay}</td>
                                            <td onClick={() => props.addRow(index)}>
                                                {applicant.firstDayAbsentFromWork
                                                    ? utilities.formatDate(
                                                        applicant.firstDayAbsentFromWork,
                                                        "MMM DD YYYY"
                                                    )
                                                    : "-"}
                                            </td>
                                            <td onClick={() => props.addRow(index)}>
                                                {applicant.xRTW
                                                    ? utilities.formatDate(applicant.xRTW, "MMM DD YYYY")
                                                    : "-"}
                                            </td>
                                            <td onClick={() => props.addRow(index)}>{applicant.isRTW ? applicant.rtwStatus : "No"}</td>
                                            <td onClick={() => props.addRow(index)}>
                                                {applicant.rtwDate
                                                    ? utilities.formatDate(applicant.rtwDate, "MMM DD YYYY")
                                                    : "-"}
                                            </td>
                                            <td onClick={() => props.addRow(index)}>{applicant.caseStatus}</td>
                                            {/* <td onClick={() => props.addRow(index)}>{applicant.statusDate
                                                ? utilities.formatDate(
                                                    applicant.statusDate,
                                                    "MMM DD YYYY"
                                                )
                                                : "-"}</td> */}
                                            {/* <td onClick={() => props.addRow(index)}>
                                                {applicant.caseMgmtID ? applicant.caseMgmtID : "-"}
                                            </td>
                                            <td onClick={() => props.addRow(index)}>{applicant.caseType ? applicant.caseType : "-"}</td> */}
                                            <td onClick={() => props.addRow(index)}>{applicant.dateClosed
                                                ? utilities.formatDate(
                                                    applicant.dateClosed,
                                                    "MMM DD YYYY"
                                                )
                                                : "-"}</td>

                                            {/* {!props.isRedirectCurrentActivityScreen && <td>
                                                <button className="download-button" onClick={() => { props.onCaseDownload(false, applicant.caseMgmtID, applicant.ein, true) }}><img src={Pdf} alt="" /></button>
                                                <button className="download-button" onClick={() => { props.onCaseDownload(false, applicant.caseMgmtID, applicant.ein, false) }}><img src={Excel} alt="" /></button>
                                            </td>} */}
                                        </tr>
                                        {applicant.otherData ? (
                                            applicant.statusDisplay == "STD" ? <>
                                                <tr>
                                                    <td colSpan="1">
                                                        {/* Case Number */}
                                                        {props.context.t("ACCOMODATION-Case-Number.CA")}

                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.CaseNumber
                                                            ? applicant.otherData.CaseNumber
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Date-Case.Entered.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.dateEntered
                                                            ? utilities.formatDate(
                                                                applicant.otherData.dateEntered,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("STD-PreviousHistoryCase.Text")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {Array.isArray(
                                                            applicant.otherData.PreviousHistory
                                                        ) &&
                                                            applicant.otherData.PreviousHistory.length > 1 ? (
                                                            <span>
                                                                {applicant.otherData.PreviousHistory.length}
                                                                &nbsp;other cases: &nbsp;
                                                            </span>
                                                        ) : "None"}
                                                        {Array.isArray(
                                                            applicant.otherData.PreviousHistory
                                                        ) && applicant.otherData.PreviousHistory.length > 1
                                                            ? applicant.otherData.PreviousHistory.map(
                                                                (history) => (
                                                                    <Fragment key={history.caseId}>
                                                                        <span>
                                                                            {history?.caseName}&nbsp;
                                                                            {moment(history?.caseDate).format("MMM DD YYYY")}
                                                                            ,
                                                                        </span>
                                                                        <br />
                                                                    </Fragment>
                                                                )
                                                            )
                                                            : null}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td>{props.context.t("STD-Employer-Statement.form.Employee-Details.label.text.EEName")}</td>
                                                    <td>
                                                        {applicant.firstName + " " + applicant.lastName}
                                                    </td>
                                                </tr> */}

                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Case-Type.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.CaseType
                                                            ? applicant.otherData.CaseType
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.managedBy
                                                            ? applicant.otherData.managedBy
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("STD-NumberOfDaysOpen.Text")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.NumberOfOpenDaysBussiness
                                                            ? `${applicant.otherData.NumberOfOpenDaysBussiness} ${props.context.t("STD-BusinessDays.Text")}`
                                                            : "-"}
                                                        {applicant.otherData.NumberOfOpenDays
                                                            ? `/${applicant.otherData.NumberOfOpenDays} ${props.context.t("STD-CalenderDays.Text")}`
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("ACCOMODATION-Date-Employer.Statement.Received.CA")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.DateEmployerStatementReceived
                                                            ? utilities.formatDate(
                                                                applicant.otherData
                                                                    .DateEmployerStatementReceived,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("ACCOMODATION-Date-Attending.Physician.Statement.Received.CA")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.PhysicianStatement
                                                            ? utilities.formatDate(
                                                                applicant.otherData.PhysicianStatement,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-File-Status.Information.CA")}</td>
                                                    <td colSpan="2">
                                                        {Array.isArray(
                                                            applicant.otherData.FileStatusInfo
                                                        ) && applicant.otherData.FileStatusInfo.length
                                                            ? applicant.otherData.FileStatusInfo.map(
                                                                (fileStatus) => (
                                                                    <Fragment key={fileStatus.statusName}>
                                                                        <span>
                                                                            &nbsp;
                                                                            {fileStatus?.statusName}
                                                                            &nbsp;-
                                                                            {moment(fileStatus?.statusDate).format("MMM DD YYYY")}

                                                                        </span>
                                                                        <br />
                                                                    </Fragment>
                                                                )
                                                            )
                                                            : null}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("ACCOMODATION-Dates-Medical.Updates.CA")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant?.otherData?.DateOfMedicalUpdates?.replace("\r\n", ",") || ""}

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {/* Date In Reduction Of Benefits */}
                                                        {props.context.t("CurrentActivity.Date In.Reduction.Of.Benefits.Text")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {
                                                            applicant.otherData.DateOfReductioninBenefits || "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {props.context.t("ACCOMODATION-Date-became.Complex.CA")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.DateCasebecame
                                                            ? utilities.formatDate(
                                                                applicant.otherData.DateCasebecame,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-AbsentFromWork.Text")}</td>
                                                    <td colSpan="2">
                                                        {Array.isArray(applicant.fileStatusInformation) &&
                                                            applicant.fileStatusInformation.length
                                                            ? (applicant.fileStatusInformation[applicant.fileStatusInformation.length - 1].statusName != "Complex Case Mgmt (CCM)"
                                                                && applicant.fileStatusInformation[applicant.fileStatusInformation.length - 1].statusName != "DCM – Special")
                                                                ? applicant.otherData.FirstDayAbsent
                                                                    ? utilities.formatDate(
                                                                        applicant.otherData.FirstDayAbsent,
                                                                        "MMM DD YYYY"
                                                                    )
                                                                    : "-" : "-" : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Case-Status.Information.CA")}</td>
                                                    <td colSpan="2">
                                                        {Array.isArray(applicant.otherData.EIDates) &&
                                                            applicant.otherData.EIDates.length
                                                            ? applicant.otherData.EIDates.map((eiDate) => (
                                                                <Fragment key={eiDate.fromDate}>
                                                                    <span>
                                                                        &nbsp;{eiDate?.status}
                                                                        &nbsp;-
                                                                        {eiDate?.fromDate ? moment(eiDate?.fromDate).format("MMM DD YYYY") : "-"}
                                                                        &nbsp;/&nbsp;
                                                                        {eiDate?.toDate ? moment(eiDate?.toDate).format("MMM DD YYYY") : "-"}
                                                                        <br />
                                                                        {"Hours:" + eiDate.hrs || eiDate.hrs}
                                                                    </span>
                                                                    <br />
                                                                    <br />

                                                                </Fragment>
                                                            ))
                                                            : null}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Restrictions-Limitations.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.RestrictionsLimitations && applicant.otherData.RestrictionsLimitations.split("\r\n").length > 0 ?
                                                            <>
                                                                <ul>
                                                                    {
                                                                        applicant.otherData.RestrictionsLimitations.split("\r\n").map((res) => (
                                                                            <li>{res}</li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </> : "-"
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("STD-ERTWDate.Text")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.ExpectedRTWDate
                                                            ? utilities.formatDate(
                                                                applicant.otherData.ExpectedRTWDate,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {/* EI Dates */}
                                                        {props.context.t("STD.EI.Dates")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {(props.selectedLanguage == "en-US") ?
                                                            (applicant.otherData.eiDatesText ? applicant.otherData.eiDatesText : null)
                                                            : (applicant.otherData.eiDatesFRText ? applicant.otherData.eiDatesFRText : null)
                                                        }
                                                        {/* {Array.isArray(applicant.otherData.EIDates) &&
                                                            applicant.otherData.EIDates.length
                                                            ? applicant.otherData.EIDates.map((eiDate) => (
                                                                <Fragment key={eiDate.fromDate}>
                                                                    <span>
                                                                        &nbsp;{eiDate?.applicant}
                                                                        &nbsp;-
                                                                        {eiDate.fromDate ? moment(
                                                                            eiDate?.fromDate,
                                                                            "MMM DD YYYY"
                                                                        ).format("MMM DD YYYY") : ""}
                                                                        &nbsp;-&nbsp;
                                                                        {eiDate.toDate ? moment(
                                                                            eiDate?.toDate,
                                                                            "MMM DD YYYY"
                                                                        ).format("MMM DD YYYY") : ""}
                                                                    </span>
                                                                    <br />
                                                                </Fragment>
                                                            ))
                                                            : null} */}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("STD.Initiate.Transfer.to.LTD.Date")}</td>
                                                    <td colSpan="2">
                                                        {/* {applicant.otherData.ExpectedRTWDate
                                                            ? utilities.formatDate(
                                                                applicant.otherData.ExpectedRTWDate,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"} */}
                                                        {applicant.otherData.ltdDate
                                                            ? utilities.formatDate(
                                                                applicant.otherData.ltdDate,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="1">{props.context.t("STD.STD.Expiry.Date")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.STDExpiryDate}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td colSpan="1">Pay Reduction Date</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.payReductionDate}
                                                    </td>
                                                </tr> */}

                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Date-Closed.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.DateClosed
                                                            ? utilities.formatDate(
                                                                applicant.otherData.DateClosed,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">
                                                        {/* Last Update to File with applicant Date */}
                                                        {props.context.t("STD.Last.Update.to.File.with.Status.Date")}
                                                    </td>
                                                    <td colSpan="2">
                                                        {/* {console.log("111applicant.otherData.lastUpdateFileStatus>>>>",applicant)} */}
                                                        {applicant.otherData.lastUpdateFileStatus ? applicant.otherData.lastUpdateFileStatus + "-" + " " + props.context.t("STD.Completed.on") + " " : null}
                                                        {applicant.otherData.LastUpdate
                                                            ? utilities.formatDate(
                                                                applicant.otherData.LastUpdate,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1">{props.context.t("ACCOMODATION-Next-action.CA")}</td>
                                                    <td colSpan="2">
                                                        {applicant.otherData.NextAction
                                                            ? applicant.otherData.NextAction
                                                            : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Notes</td>
                                                    <td>{applicant.otherData.notes ? applicant.otherData.notes : "-"}</td>
                                                </tr>
                                                {applicant.statusDisplay == 'Accommodation' &&
                                                    <tr>
                                                        {/* <tr> */}
                                                        <td>{props.context.t("ACCOMODATION-Accommodation-Type.CA")}</td>
                                                        {/* <td>{applicant.otherData.acmdType == "0" || applicant.otherData.acmdType == "1" ? (applicant.otherData.acmdType == 1 ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("ACCOMODATION-Permanent.CA")) : "-"}</td> */}
                                                        <td>{applicant.otherData.acmdType == "1" || applicant.otherData.acmdType == "2" || applicant.otherData.acmdType == "3" ? (applicant.otherData.acmdType == "1" ? props.context.t("ACCOMODATION-Permanent.CA") : applicant.otherData.acmdType == "2" ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("AIR-Accident-Information.form.label.text.OvertimeToInjuryType.NA")) : "-"}</td>
                                                        {/* </tr> */}
                                                    </tr>
                                                }
                                            </> :
                                                applicant.statusDisplay == "Accommodation" || applicant.statusDisplay == "CCM" ? <>
                                                    <tr>
                                                        <td colSpan="1">
                                                            {/* Case Number */}
                                                            {props.context.t("ACCOMODATION-Case-Number.CA")}

                                                        </td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.CaseNumber
                                                                ? applicant.otherData.CaseNumber
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Date-Case.Entered.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.dateEntered
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.dateEntered,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Date-Closed.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.DateClosed
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.DateClosed,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    {/* <tr>
                                                    <td>{props.context.t("STD-Employer-Statement.form.Employee-Details.label.text.EEName")}</td>
                                                    <td>
                                                        {applicant.firstName + " " + applicant.lastName}
                                                    </td>
                                                </tr> */}

                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Case-Type.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.CaseType
                                                                ? applicant.otherData.CaseType
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.managedBy
                                                                ? applicant.otherData.managedBy
                                                                : "-"}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1">
                                                            {props.context.t("ACCOMODATION-Date-Employer.Statement.Received.CA")}
                                                        </td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.DateEmployerStatementReceived
                                                                ? utilities.formatDate(
                                                                    applicant.otherData
                                                                        .DateEmployerStatementReceived,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1">
                                                            {props.context.t("ACCOMODATION-Date-Attending.Physician.Statement.Received.CA")}
                                                        </td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.PhysicianStatement
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.PhysicianStatement,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Date-First.Seen.by.MD.CA")}</td>
                                                        <td colSpan="2">
                                                            {/* {applicant.otherData.seenByMDDate} */}
                                                            {applicant.otherData.seenByMDDate
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.seenByMDDate,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-File-Status.Information.CA")}</td>
                                                        <td colSpan="2">
                                                            {Array.isArray(
                                                                applicant.otherData.FileStatusInfo
                                                            ) && applicant.otherData.FileStatusInfo.length
                                                                ? applicant.otherData.FileStatusInfo.map(
                                                                    (fileStatus) => (
                                                                        <Fragment key={fileStatus.statusName}>
                                                                            <span>
                                                                                &nbsp;
                                                                                {fileStatus?.statusName}
                                                                                &nbsp;-
                                                                                {moment(fileStatus?.statusDate).format("MMM DD YYYY")}

                                                                            </span>
                                                                            <br />
                                                                        </Fragment>
                                                                    )
                                                                )
                                                                : null}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">
                                                            {props.context.t("ACCOMODATION-Dates-Medical.Updates.CA")}
                                                        </td>
                                                        <td colSpan="2">
                                                            {applicant?.otherData?.DateOfMedicalUpdates?.replace("\r\n", ",") || ""}

                                                        </td>
                                                    </tr>



                                                    <tr>
                                                        <td colSpan="1">
                                                            {props.context.t("ACCOMODATION-Date-became.Complex.CA")}
                                                        </td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.DateCasebecame
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.DateCasebecame,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Case-Status.Information.CA")}</td>
                                                        <td colSpan="2">
                                                            {Array.isArray(applicant.otherData.EIDates) &&
                                                                applicant.otherData.EIDates.length
                                                                ? applicant.otherData.EIDates.map((eiDate) => (
                                                                    <Fragment key={eiDate.fromDate}>
                                                                        <span>
                                                                            &nbsp;{eiDate?.status}
                                                                            &nbsp;-
                                                                            {eiDate?.fromDate ? moment(eiDate?.fromDate).format("MMM DD YYYY") : "-"}
                                                                            &nbsp;/&nbsp;
                                                                            {eiDate?.toDate ? moment(eiDate?.toDate).format("MMM DD YYYY") : "-"}
                                                                            <br />&nbsp;
                                                                            {"Hours:" + eiDate.hrs || eiDate.hrs}
                                                                        </span>
                                                                        <br />
                                                                        <br />

                                                                    </Fragment>
                                                                ))
                                                                : null}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Restrictions-Limitations.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.RestrictionsLimitations && applicant.otherData.RestrictionsLimitations.split("\r\n").length > 0 ?
                                                                <>
                                                                    <ul>
                                                                        {
                                                                            applicant.otherData.RestrictionsLimitations.split("\r\n").map((res) => (
                                                                                <li>{res}</li>
                                                                            ))
                                                                        }
                                                                    </ul>
                                                                </> : "-"
                                                            }
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1">
                                                            {/* Last Update to File with applicant Date */}
                                                            {props.context.t("STD.Last.Update.to.File.with.Status.Date")}
                                                        </td>
                                                        <td colSpan="2">
                                                            {/* {console.log("222applicant.otherData.lastUpdateFileStatus>>>>",applicant.otherData.lastUpdateFileStatus)} */}

                                                            {applicant.otherData.lastUpdateFileStatus ? applicant.otherData.lastUpdateFileStatus + "-" + " " + props.context.t("STD.Completed.on") + " " : null}

                                                            {applicant.otherData.LastUpdate
                                                                ? utilities.formatDate(
                                                                    applicant.otherData.LastUpdate,
                                                                    "MMM DD YYYY"
                                                                )
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="1">{props.context.t("ACCOMODATION-Next-action.CA")}</td>
                                                        <td colSpan="2">
                                                            {applicant.otherData.NextAction
                                                                ? applicant.otherData.NextAction
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Notes</td>
                                                        <td>{applicant.otherData.notes ? applicant.otherData.notes : "-"}</td>
                                                    </tr>

                                                    <tr>
                                                        {/* <tr> */}
                                                        <td>{props.context.t("ACCOMODATION-Accommodation-Type.CA")}</td>
                                                        {/* <td>{applicant.otherData.acmdType == "0" || applicant.otherData.acmdType == "1" ? (applicant.otherData.acmdType == 1 ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("ACCOMODATION-Permanent.CA")) : "-"}</td> */}
                                                        <td>{applicant.otherData.acmdType == "1" || applicant.otherData.acmdType == "2" || applicant.otherData.acmdType == "3" ? (applicant.otherData.acmdType == "1" ? props.context.t("ACCOMODATION-Permanent.CA") : applicant.otherData.acmdType == "2" ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("AIR-Accident-Information.form.label.text.OvertimeToInjuryType.NA")) : "-"}</td>
                                                        {/* </tr> */}
                                                    </tr>

                                                </> : null
                                        ) : null}
                                    </Fragment>
                                    : null
                            ))
                            }
                        </tbody>
                    </table>
                </>
                : null}
        </>
    )
}
export default StdAcmdCaseDetailsTableComponent;